import {LmLeadService} from "./service/api/lm-lead.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";


export const LM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['lm.LmLeadData', {route: '/lm/lmLeadDatas'}],
            ['lm.LmLead', {route: '/lm/lmLeads', service: LmLeadService}],
            ['lm.LmLeadAddress', {route: '/lm/lmLeadAddresss'}],
            ['lm.LmLeadStatusType', {route: '/lm/lmLeadStatusTypes'}],
            ['lm.LmLeadSourceType', {route: '/lm/lmLeadSourceTypes'}],
            ['lm.LmLeadContact', {route: '/lm/lmLeadContacts'}],
            ['lm.LmLeadTypeField', {route: '/lm/lmLeadTypeFields'}],
            ['lm.LmLeadQualityType', {route: '/lm/lmLeadQualityTypes'}],
            ['lm.LmLeadChannel', {route: '/lm/lmLeadChannels'}],
            ['lm.LmLeadType', {route: '/lm/lmLeadTypes'}],
            ['lm.LmLeadDataField', {route: '/lm/lmLeadDataFields'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
